import React, { useCallback, useEffect, useRef,useState } from 'react';
import { Modal, ModalHeader } from 'react-bootstrap';
import  goggles  from "../../assets/no-goggles.svg";
import  hat  from "../../assets/no-hat.svg";
import  mask  from "../../assets/no-mask.svg";
import  defaultfaceimage  from "../../assets/default-face.svg";
// import { stopStream } from '../../helpers';
import WebcamCapture from '../../components/WebcamCapture/WebcamCapture';

function FaceRegistration({
    showFaceRegistrationModal, setShowFaceRegistrationModal, handleDataUpdate,
    userData,
}) {
  // const videoRef = useRef(null);
  // const outputCanvasRef = useRef(null);
  const webcamRef = useRef(null);
  const [showCaptureImage, setShowCaptureImage] = useState(false);
  const [showCanvas, setShowCanvas] = useState(false);
  const [showVideo, setShowVideo] = useState(false);
  const [showSamplePhoto, setShowSamplePhoto] = useState(false);

  const MAX_FILE_SIZE_MB = 25;

  const handleCaptureClick = useCallback(() => {
    // setShowCanvas(true);
    const imageSrc = webcamRef?.current?.getScreenshot();
    handleDataUpdate('userPhoto', imageSrc);
    setShowCanvas(true);
    setShowVideo(false);
    setShowFaceRegistrationModal(false);
  }, [webcamRef]);

  const handleCaptureImageCTAClick = (event) => {
    event.preventDefault();
    setShowVideo(true);
    setShowCaptureImage(true);
    setShowSamplePhoto(false);
  };


  const handleFileUpload = useCallback((event) => {
    const file = event.target.files[0];

    if (file && validateFile(file)) {
        const reader = new FileReader();
        reader.onloadend = () => {
            const imageSrc = reader.result;
            handleDataUpdate('userPhoto', imageSrc);
            setShowCanvas(true);
            setShowVideo(false);
            setShowFaceRegistrationModal(false);
        };
        reader.readAsDataURL(file);
    }
}, [handleDataUpdate, setShowCanvas, setShowVideo, setShowFaceRegistrationModal]);



const validateFile = (file) => {
  // Validate file type (accept only PNG and JPEG)
  const allowedTypes = ['image/png', 'image/jpeg'];
  if (!allowedTypes.includes(file.type)) {
      alert('Please select a PNG or JPEG image.');
      return false;
  }

  // Validate file size
  const maxSizeBytes = MAX_FILE_SIZE_MB * 1024 * 1024; // Convert MB to Bytes
  if (file.size > maxSizeBytes) {
      alert(`File size must be up to ${MAX_FILE_SIZE_MB} MB.`);
      return false;
  }

  return true;
};

const handleUploadLocalImage = () => {
  const fileInput = document.getElementById('localImageInput');
  if (fileInput) {
      fileInput.click();
  }
};

  return (
    <Modal
      size='md'
      aria-labelledby="contained-modal-title-vcenter"
      centered
      fullscreen={true}
      show={showFaceRegistrationModal}
      onHide={() => setShowFaceRegistrationModal(false)}
    >
        <ModalHeader>
          <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => setShowFaceRegistrationModal(false)}>
              <span aria-hidden="true">&times;</span>
          </button>
        </ModalHeader>
        <div className="d-flex justify-content-center">
          <div className="col-md-12">
            <div className="d-flex justify-content-center mt-3 pb-5">
              <div className="col-md-8">
                <div >
                  <div>
                    <div className="optContainer">
                      <h2 className="text-left">Capture your face</h2>
                      <div className="d-flex justify-content-center image-container">
                        {
                          !(showCaptureImage || showSamplePhoto) && <img src={defaultfaceimage} id="default-image" className="image-fluid" alt="Default" />
                        }
                        {
                          showSamplePhoto && <img src='https://platform.betterplace.co.in/attend/192fa53c6653418de2d8594b04212bbd.png' id="sample-image" style={{width: '100%'}} className="image-fluid" alt="sample" />
                        }
                        {showVideo && <WebcamCapture webcamRef={webcamRef} handleCaptureClick={handleCaptureClick} />}
                        {
                          showCanvas && userData?.userPhoto && <img src={userData?.userPhoto} alt='captured' />
                        }
                      </div>
                      <div className="row">
                        <div className="col-sm-12 m-auto">
                          <div className="d-flex justify-content-around">
                            <img src={goggles} alt="No goggles"/>
                            <img src={hat} alt="No Hat"/>
                            <img src={mask} alt="No Mask"/>
                          </div>
                          <div className="m-auto image-capture-instruction">
                            <p className="text-center">
                              No goggles, no hats, no masks, no blurred image
                            </p>
                            <div className="d-flex justify-content-center">
                              <button onClick={() => {
                                setShowSamplePhoto(true);
                                // stopStream(videoRef);
                                setShowVideo(false);
                                setShowCaptureImage(false);
                                }} type="button" className="btn btn-link sample-photo p-0 mb-3" id="viewSamplePhoto">View sample photo</button>
                            </div>
                            <div className="capture-submit-cta text-center justify-content-center">
                              {/* <div className="capture-submit-cta text-center mt-2 justify-content-center">
                                <input type="file" accept="image/*" onChange={handleFileUpload} className="form-control-file mt-2" id="localImageInput" style={{ display: 'none' }} />
                                <button type="button" className="btn btn-dark mt-2 custom-input-2" onClick={handleUploadLocalImage}>Upload from gallery</button>
                              </div> */}
                              { showCaptureImage ?
                                <button className="btn mt-3 custom-input btn btn-dark" id="captureBtn" onClick={handleCaptureClick}>Capture Image</button>
                                : <button type="submit" className="btn mt-3 custom-input btn btn-dark" id="captureFaceCTA" onClick={handleCaptureImageCTAClick}>Capture face</button>
                              }
                            </div>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </Modal>
  )
}

export default FaceRegistration;